import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaInfoCircle, FaQuestionCircle } from "react-icons/fa";

const InfoIcon = ({ text, icon = 'info' }) => (
  <OverlayTrigger
    placement="top"
    overlay={<Tooltip className="text-start">{text}</Tooltip>}
  >
    <span className="ms-1 text-muted cursor-pointer">
      {icon === 'info' ? <FaInfoCircle size={14} /> : <FaQuestionCircle size={12} />}
    </span>
  </OverlayTrigger>
);

export default InfoIcon;